/* istanbul ignore file */
import { theme } from '@noths/polaris-client-ribbons-base';
import { css } from 'styled-components';

const { spacing } = theme;

export const wrapper = css`
  text-align: center;
`;

export const title = css`
  margin: 0 0 ${spacing.lg}px 0;
`;

export const caption = css`
  margin: ${spacing.lg}px 0 0;
`;
